module.exports = __webpack_public_path__ + "static/media/newarrival-2.70fd2699.jpg";